import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { COLOR_CAMPAIGN_HAPPY_WEEKEND, COLOR_CAMPAIGN_BEST_PRIMARY, COLOR_CAMPAIGN_BLACK_WEEK, COLOR_CAMPAIGN_BETTER_SECONDARY, COLOR_CAMPAIGN_GOOD_PRIMARY, COLOR_TEXT, COLOR_TEXT_INVERSE } from '../../tokens/js/variables.default.js';

// @ts-nocheck
var PromotionBadge = styled.div.withConfig({
  displayName: "PromotionBadgestyle__PromotionBadge",
  componentId: "sc-1xat1ay-0"
})(["display:inline-flex;", " align-items:center;picture{width:auto;}img{", " ", "}gap:10px;"], mq.sMax(css(["width:calc(100% - 2rem);"])), mq.sMax(css(["height:", ";"], function (props) {
  return props.$mobileSize ? "".concat(props.$mobileSize, "px") : '40px';
})), mq.s(css(["height:", ";"], function (props) {
  return props.$desktopSize ? "".concat(props.$desktopSize, "px") : '40px';
})));
var PromotionIconWrapper = styled.div.withConfig({
  displayName: "PromotionBadgestyle__PromotionIconWrapper",
  componentId: "sc-1xat1ay-1"
})(["border-radius:8px;width:", ";padding:", ";line-height:0px;display:flex;justify-content:center;gap:12px;background-color:", ";.PromotionIcon{fill:", ";}"], function (_ref) {
  var fullWidthBg = _ref.fullWidthBg;
  return fullWidthBg ? '100%' : 'auto';
}, function (_ref2) {
  var fullWidthBg = _ref2.fullWidthBg;
  return fullWidthBg ? '8px 24px' : '8px 16px';
}, function (_ref3) {
  var variant = _ref3.variant;
  switch (variant) {
    case 'yellow':
      return COLOR_CAMPAIGN_GOOD_PRIMARY;
    case 'green':
      return COLOR_CAMPAIGN_BETTER_SECONDARY;
    case 'black':
      return COLOR_CAMPAIGN_BLACK_WEEK;
    case 'orange':
      return COLOR_CAMPAIGN_HAPPY_WEEKEND;
    case 'red':
      return COLOR_CAMPAIGN_BEST_PRIMARY;
    default:
      return COLOR_CAMPAIGN_HAPPY_WEEKEND;
  }
}, function (_ref4) {
  var variant = _ref4.variant;
  if (variant === 'yellow' || variant === 'orange') {
    return COLOR_TEXT;
  }
  return COLOR_TEXT_INVERSE;
});
var PromotionLabel = styled.span.withConfig({
  displayName: "PromotionBadgestyle__PromotionLabel",
  componentId: "sc-1xat1ay-2"
})(["font:var(--font-headline-xs);width:100%;color:", ";"], function (_ref5) {
  var fullWidthBg = _ref5.fullWidthBg,
    variant = _ref5.variant;
  if (!fullWidthBg) {
    return COLOR_TEXT;
  }
  if (variant === 'yellow' || variant === 'orange') {
    return COLOR_TEXT;
  }
  return COLOR_TEXT_INVERSE;
});

export { PromotionBadge, PromotionIconWrapper, PromotionLabel };
//# sourceMappingURL=PromotionBadge.style.js.map
